// extracted by mini-css-extract-plugin
export default {"liquidityPools":"LiquidityPools_liquidityPools__l8wH8"};